import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyFieldSelectProps, FormlySelectModule } from '@ngx-formly/core/select';
import { Select } from '@openng/optimus-ui/select';
import { SelectSearchTextPipe } from '../../../pipes';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

interface SelectProps extends FieldWrapperProps, FormlyFieldSelectProps {
  virtualScroll?: boolean;
  virtualScrollSize?: number;

  groupLabelProp?: string;
  groupChildrenProp?: string;

  canFilter?: boolean;
  searchByValue?: boolean;
  editable?: boolean;
  scrollHeight?: string;

  optionLabel?: string;
  optionValue?: string;

  showClear?: boolean;
}

export interface SelectFieldConfig extends FormlyFieldConfig<SelectProps> {
  type?: 'select' | Type<SelectTypeComponent>;
}

@Component({
  selector: 'lib-formly-select-type',
  templateUrl: './select-type.component.html',
  styleUrl: './select-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslocoDirective,
    Select,
    ReactiveFormsModule,
    FormlyModule,
    NgClass,
    AsyncPipe,
    FormlySelectModule,
    SelectSearchTextPipe
  ]
})
export class SelectTypeComponent extends FieldType<FieldTypeConfig<SelectProps>> {}
